import {
  setTransitionActive
} from '../app/actions'

const createExitPageInternal = pageName => () => ({
  type: `EXIT_${pageName}`
})

export const createExitPage = pageName => {
  return () => dispatch => {
    const exitPageAction = createExitPageInternal(pageName)
    dispatch(exitPageAction())
    dispatch(setTransitionActive(true))
  }
}

const createExitCompletePageInternal = pageName => () => ({
  type: `EXIT_COMPLETE_${pageName}`
})

export const createExitCompletePage = pageName => {
  return () => dispatch => {
    const exitCompletePageAction = createExitCompletePageInternal(pageName)
    dispatch(exitCompletePageAction())
    dispatch(setTransitionActive(false))
  }
}

const createEnterPageInternal = pageName => () => ({
  type: `ENTER_${pageName}`
})

export const createEnterPage = pageName => {
  return () => dispatch => {
    const enterPageAction = createEnterPageInternal(pageName)
    dispatch(enterPageAction())
    dispatch(setTransitionActive(true))
  }
}

const createEnterCompletePageInternal = pageName => () => ({
  type: `ENTER_COMPLETE_${pageName}`
})

export const createEnterCompletePage = pageName => {
  return () => dispatch => {
    const enterCompletePageAction = createEnterCompletePageInternal(pageName)
    dispatch(enterCompletePageAction())
    dispatch(setTransitionActive(false))
  }
}

export const createUpdateScroll = pageName => st => ({
  type: `UPDATE_ST_${pageName}`,
  payload: st
})

export const createSaveScroll = pageName => st => ({
  type: `SAVE_ST_${pageName}`,
  payload: st
})

export const createSetPageScroll = pageName => st => ({
  type: `SET_PAGE_SCROLL_${pageName}`,
  payload: st
})

export const createUpdateHeight = pageName => st => ({
  type: `UPDATE_PH_${pageName}`,
  payload: st
})

export const createSetPageScrollEnd = pageName => isScrollEnd => ({
  type: `SET_PAGE_SCROLL_END_${pageName}`,
  payload: isScrollEnd
})

export const createUnsetReset = pageName => st => ({
  type: `UNSET_PAGE_SCROLL_${pageName}`
})



// WEBPACK FOOTER //
// ./src/components/create-page/create-page-actions.js